import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import SearchBar from './components/SearchBar';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import WikiListPage from './pages/WikiListPage';
import WikiDetailPage from './pages/WikiDetailPage';
import WikiEditorPage from './pages/WikiEditorPage';
import SearchResultsPage from './pages/SearchResultsPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-background">
          <Header
            onSearchToggle={() => setSearchOpen(!searchOpen)}
            searchOpen={searchOpen}
          />
          <SearchBar
            isOpen={searchOpen}
            onClose={() => setSearchOpen(false)}
          />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/wiki" element={<WikiListPage />} />
            <Route path="/wiki/:id" element={<WikiDetailPage />} />
            <Route path="/search" element={<SearchResultsPage />} />
            <Route
              path="/wiki/new"
              element={
                <ProtectedRoute>
                  <WikiEditorPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wiki/:id/edit"
              element={
                <ProtectedRoute>
                  <WikiEditorPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
